/*
  Feature flag gate. Reads from runtime config. Returns null (hides the
  children) if the flag is false. Admins can flip flags via /_vh-admin.

  Usage:
    <FeatureGate flag="feature_routines">
      <Link to="/routines">…</Link>
    </FeatureGate>
*/
import { useEffect, useState } from "react";
import { getConfig } from "../lib/runtimeConfig";

export function isFeatureEnabled(flag) {
  const cfg = getConfig();
  const flags = cfg.feature_flags || {};
  // Default to true if the flag isn't in the config so existing behaviour
  // doesn't break when new flags are added to the backend.
  return flags[flag] !== false;
}

export default function FeatureGate({ flag, fallback = null, children }) {
  const [enabled, setEnabled] = useState(isFeatureEnabled(flag));
  useEffect(() => {
    const h = () => setEnabled(isFeatureEnabled(flag));
    window.addEventListener("vh-config-loaded", h);
    return () => window.removeEventListener("vh-config-loaded", h);
  }, [flag]);
  if (!enabled) return fallback;
  return children;
}
